import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { InitService } from "src/app/shared/services/init.service";
import { MobileTanService } from "src/app/modules/option/mobile-tan.service";
import { environment } from "src/environments/environment";

@Injectable()
export class ConfigService {
  private readonly router = inject(Router);
  private readonly initService = inject(InitService);
  private readonly mobileTanService = inject(MobileTanService);

  showMobileTAN() {
    this.mobileTanService.openDialog();
  }

  changeRight() {
    environment.production ? this.router.navigateByUrl("/").then() : this.router.navigate(["settings", "internal"]).then();
  }

  showPackageOverview() {
    this.router.navigate(["Reception", "PackageOverview"]).then();
  }

  logout() {
    sessionStorage.clear();
    localStorage.removeItem("user_preferences");

    const logoutUrl = this.initService.getApiUrl("/api/logout");
    window.location.href = logoutUrl;
  }
}
